"use strict";
var TemplateView; // required after export is defined to avoid circular dependency
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var normalizeToView = module.exports = function (options) {
    // TODO: test this
    var view;
    var constructorOptions;
    var defaultParentElement;
    var newContent;
    var useDefaultParentElement;
    if (undefined === options.content && !options.Constructor) {
        throw new Error("normalizeToView requires options.Constructor if options.content is missing");
    }
    options = $.extend({
        defaultParentElement: undefined,
        defaultContext: undefined,
        defaultTemplateVars: undefined,
        content: undefined,
        Constructor: TemplateView
    }, options);
    if (false === options.content) {
        return false;
    }
    if (options.content instanceof $) {
        options.content = options.content.get(0);
        view = new Backbone.View({el: options.content});
    }
    // content can't be jQuery below this line
    if (options.content instanceof global.HTMLElement) {
        view = new Backbone.View({el: options.content});
    }
    if (options.content && options.content.hasOwnProperty('el')) { // assume it's a backbone-style view if it has an `el` property
        view = options.content;
    }
    if (options.content instanceof Function) {
        defaultParentElement = undefined;
        if (options.defaultParentElement) {
            defaultParentElement = $(options.defaultParentElement).get(0);
        }
        newContent = options.content.call(options.defaultContext, defaultParentElement);
        if (!newContent) {
            return newContent;
        }
        view = normalizeToView(_.extend({}, options, {content: newContent}));
    }
    if (!view && options.Constructor) {
        constructorOptions = options.content;
        useDefaultParentElement = true;
        if (options.Constructor && _.result(options.Constructor.prototype.template, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (_.result(constructorOptions, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (useDefaultParentElement) {
            constructorOptions = _.extend({el: options.defaultParentElement}, constructorOptions);
        }
        if (options.Constructor.prototype.templateVars === TemplateView.prototype.templateVars && !constructorOptions.templateVars && !constructorOptions.model) {
            constructorOptions = _.extend({templateVars: options.defaultTemplateVars}, constructorOptions);
        }
        view = new options.Constructor(constructorOptions);
    }
    return view;
};
TemplateView = require('bunsen/views/TemplateView');



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/normalizeToView.js
// module id = 502
// module chunks = 4 6 7 8 9 13 17